import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@env/environment';
import { AppConstant } from '@app/shared/constants';
import {APIResponse} from '@app/shared/services/core/ICore.interface';
import {GetStoreAdminDashboardDataInterface} from '@app/shared/services/dashboard/GetStoreAdminDashboardData.interface';
import {GetSuperAdminDashboardDataInterface} from '@app/shared/services/dashboard/GetSuperAdminDashboardData.interface';
import {GetSuperAdminRevnueChartDataInterface} from '@app/shared/services/dashboard/GetSuperAdminRevnueChartData.interface';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor(private http: HttpClient) { }

  GetSuperAdminDashboardData() {
    return this.http.get<APIResponse<GetSuperAdminDashboardDataInterface>>(environment.baseUrl + AppConstant.GET_SUPER_ADMIN_DASHBOARD_DATA);
  }

  GetStoreAdminDashboardData(userid: any) {
    const headers = new HttpHeaders();
    const headers_1 =  headers.append('Authorization', 'Bearer ' + localStorage.getItem('userToken'));
    return this.http.get<APIResponse<GetStoreAdminDashboardDataInterface>>(environment.baseUrl + AppConstant.GET_STORE_ADMIN_DASHBOARD_DATA + '?UserId=' + userid, {headers: headers_1});
    // + '?UserId=' + userid
  }

  GetTotalEndUsersOfStore(StoreId: any) {
    const headers = new HttpHeaders();
    const headers_1 =  headers.append('Authorization', 'Bearer ' + localStorage.getItem('userToken'));
    return this.http.get<APIResponse<number>>(environment.baseUrl + AppConstant.GET_TOTAL_ENDUSERS_OFSTORE + '?StoreId=' + StoreId, {headers: headers_1});
  }

  GetOrdersPerStore(StoreId: any) {
    const headers = new HttpHeaders();
    const headers_1 =  headers.append('Authorization', 'Bearer ' + localStorage.getItem('userToken'));
    return this.http.get<APIResponse<number>>(environment.baseUrl + AppConstant.GET_ORDERS_PER_STORE + '?StoreId=' + StoreId, {headers: headers_1});
  }

  GetSuperAdminRevnueChartData(StoreId: any) {
    const headers = new HttpHeaders();
    const headers_1 =  headers.append('Authorization', 'Bearer ' + localStorage.getItem('userToken'));
    return this.http.get<APIResponse<GetSuperAdminRevnueChartDataInterface>>(environment.baseUrl + AppConstant.GET_SUPER_ADMIN_REVENUE_CHART_DATA + '?StoreId=' + StoreId, {headers: headers_1});
  }
}
